import { createSearchEngine } from '../engine';

const QUERY_PARAM = 'q';

export const duckDuckGoSearch = createSearchEngine({
  safeParam: {
    key: 'kp',
    value: '1',
  },
  isSearch: (url: URL): boolean => {
    return (
      /^(www\.)?duckduckgo\.com/.test(url.hostname) &&
      url.pathname === '/' &&
      url.searchParams.has(QUERY_PARAM)
    );
  },
});
